import { useState } from "react";
import { DataTable } from "../components/DataTable";

type WishlistItem = {
  id: string;
  customer: string;
  email: string;
  product: string;
  category: string;
  price: number;
  addedOn: string;
  inStock: boolean;
};

const initialWishlists: WishlistItem[] = [
  { id: "wl1",  customer: "Priya Sharma",   email: "priya@email.com",   product: "Diamond Solitaire Ring",   category: "Rings",     price: 42000, addedOn: "2026-05-18", inStock: true  },
  { id: "wl2",  customer: "Anjali Mehta",   email: "anjali@email.com",  product: "Gold Jhumka Earrings",     category: "Earrings",  price: 8500,  addedOn: "2026-05-17", inStock: true  },
  { id: "wl3",  customer: "Sunita Rao",     email: "sunita@email.com",  product: "Ruby Necklace Set",        category: "Necklace",  price: 28000, addedOn: "2026-05-17", inStock: false },
  { id: "wl4",  customer: "Meera Joshi",    email: "meera@email.com",   product: "Emerald Bangles (Pair)",   category: "Bangles",   price: 15000, addedOn: "2026-05-16", inStock: true  },
  { id: "wl5",  customer: "Kavya Nair",     email: "kavya@email.com",   product: "Silver Anklet",            category: "Anklets",   price: 2200,  addedOn: "2026-05-15", inStock: true  },
  { id: "wl6",  customer: "Divya Singh",    email: "divya@email.com",   product: "Diamond Solitaire Ring",   category: "Rings",     price: 42000, addedOn: "2026-05-14", inStock: true  },
  { id: "wl7",  customer: "Ritu Agarwal",   email: "ritu@email.com",    product: "Pearl Drop Earrings",      category: "Earrings",  price: 5800,  addedOn: "2026-05-13", inStock: false },
  { id: "wl8",  customer: "Pooja Iyer",     email: "pooja@email.com",   product: "Gold Mangalsutra",         category: "Necklace",  price: 35000, addedOn: "2026-05-12", inStock: true  },
  { id: "wl9",  customer: "Sneha Pillai",   email: "sneha@email.com",   product: "Sapphire Ring",            category: "Rings",     price: 22000, addedOn: "2026-05-11", inStock: true  },
  { id: "wl10", customer: "Lakshmi Verma",  email: "lakshmi@email.com", product: "Rose Gold Bracelet",       category: "Bangles",   price: 9500,  addedOn: "2026-05-10", inStock: false },
];

const STYLES = `
  .wl-stats { display:grid; grid-template-columns:repeat(auto-fit,minmax(130px,1fr)); gap:14px; margin-bottom:4px; }
  .wl-stat { background:#fff; border:1px solid #f0ebe4; border-radius:16px; padding:16px 18px; box-shadow:0 2px 8px rgba(26,18,8,.06); }
  .wl-stat-lbl { font-size:11px; font-weight:700; color:#9b8878; text-transform:uppercase; letter-spacing:.6px; margin-bottom:5px; display:flex; align-items:center; gap:5px; }
  .wl-stat-val { font-size:20px; font-weight:800; color:#1a1208; }

  .wl-card { background:#fff; border-radius:16px; border:1px solid #f0ebe4; box-shadow:0 2px 12px rgba(26,18,8,.07); overflow:hidden; }
  .wl-card-head { display:flex; align-items:center; justify-content:space-between; padding:16px 22px; border-bottom:1.5px solid #f5f0eb; background:linear-gradient(135deg,#1a1208 0%,#2d1e0f 100%); flex-wrap:wrap; gap:10px; }
  .wl-card-title { font-size:15px; font-weight:800; color:#fff; display:flex; align-items:center; gap:8px; }
  .wl-filter-sel { padding:6px 10px; border:1.5px solid rgba(255,255,255,.15); border-radius:8px; background:rgba(255,255,255,.07); color:#fff; font-size:12px; font-family:inherit; outline:none; }
  .wl-filter-sel option { background:#1a1208; }

  .wl-stock-badge { display:inline-flex; align-items:center; gap:4px; padding:3px 9px; border-radius:20px; font-size:11.5px; font-weight:700; }
  .wl-notify-btn { padding:5px 12px; border-radius:8px; border:1.5px solid #ede6df; background:#fdf8f3; color:#1a1208; font-size:11.5px; font-weight:700; cursor:pointer; font-family:inherit; transition:all .15s; display:inline-flex; align-items:center; gap:5px; }
  .wl-notify-btn:hover { background:var(--theme); color:#fff; border-color:var(--theme); }
  .wl-notify-btn:disabled { opacity:.4; cursor:not-allowed; }

  .wl-toast { position:fixed; bottom:24px; right:24px; background:#1a1208; color:#fff; padding:12px 20px; border-radius:12px; font-size:13px; font-weight:600; z-index:9999; animation:wlToastIn .3s ease; box-shadow:0 8px 24px rgba(0,0,0,.25); display:flex; align-items:center; gap:8px; }
  @keyframes wlToastIn { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:none} }
`;

export function WishlistPage() {
  const [items, setItems] = useState<WishlistItem[]>(initialWishlists);
  const [filterCat, setFilterCat] = useState("All");
  const [filterStock, setFilterStock] = useState("All");
  const [toast, setToast] = useState("");
  const [notified, setNotified] = useState<Set<string>>(new Set());

  const categories = ["All", ...Array.from(new Set(items.map(i => i.category)))];

  const filtered = items.filter(i =>
    (filterCat === "All" || i.category === filterCat) &&
    (filterStock === "All" || (filterStock === "In Stock" ? i.inStock : !i.inStock))
  );

  function notify(item: WishlistItem) {
    setNotified(prev => new Set([...prev, item.id]));
    setToast(`Notification sent to ${item.customer} for "${item.product}"`);
    setTimeout(() => setToast(""), 3000);
  }

  const totalValue = items.reduce((s, i) => s + i.price, 0);
  const outOfStock = items.filter(i => !i.inStock).length;

  const cols = [
    { key: "customer", label: "Customer",  render: (row: WishlistItem) => (
      <div>
        <div style={{ fontWeight: 700, color: "#1a1208", fontSize: 13 }}>{row.customer}</div>
        <div style={{ fontSize: 11, color: "#9b8878" }}>{row.email}</div>
      </div>
    )},
    { key: "product",  label: "Product",   render: (row: WishlistItem) => (
      <div>
        <div style={{ fontWeight: 600, fontSize: 13, color: "#1a1208" }}>{row.product}</div>
        <div style={{ fontSize: 11, color: "#9b8878" }}>{row.category}</div>
      </div>
    )},
    { key: "price",    label: "Price",     render: (row: WishlistItem) => <strong>₹{row.price.toLocaleString("en-IN")}</strong> },
    { key: "addedOn",  label: "Added On",  render: (row: WishlistItem) => row.addedOn },
    { key: "inStock",  label: "Stock",     render: (row: WishlistItem) =>
      <span className="wl-stock-badge" style={{ color: row.inStock ? "#16a34a" : "#dc2626", background: row.inStock ? "#dcfce7" : "#fee2e2" }}>
        <i className={`bi ${row.inStock ? "bi-check-circle-fill" : "bi-x-circle-fill"}`}></i>
        {row.inStock ? "In Stock" : "Out of Stock"}
      </span>
    },
    { key: "id", label: "Action", render: (row: WishlistItem) =>
      <button
        className="wl-notify-btn"
        disabled={row.inStock || notified.has(row.id)}
        onClick={() => notify(row)}
      >
        <i className="bi bi-bell"></i>
        {notified.has(row.id) ? "Sent" : "Notify"}
      </button>
    },
  ];

  return (
    <div className="d-grid gap-3">
      <style>{STYLES}</style>

      <div className="wl-stats">
        {[
          { lbl: "Total Wishlisted", val: items.length,             icon: "bi-heart-fill",     color: "#ec4899" },
          { lbl: "Unique Customers", val: new Set(items.map(i=>i.customer)).size, icon: "bi-people-fill", color: "#2563eb" },
          { lbl: "Wishlist Value",   val: `₹${(totalValue/1000).toFixed(0)}K`, icon: "bi-currency-rupee", color: "#16a34a" },
          { lbl: "Out of Stock",     val: outOfStock,               icon: "bi-x-circle-fill",  color: "#dc2626" },
        ].map(s => (
          <div key={s.lbl} className="wl-stat">
            <div className="wl-stat-lbl"><i className={`bi ${s.icon}`} style={{ color: s.color }}></i>{s.lbl}</div>
            <div className="wl-stat-val">{s.val}</div>
          </div>
        ))}
      </div>

      <div className="wl-card">
        <div className="wl-card-head">
          <div className="wl-card-title"><i className="bi bi-heart-fill"></i> User Wishlists</div>
          <div style={{ display: "flex", gap: 8 }}>
            <select className="wl-filter-sel" value={filterCat} onChange={e => setFilterCat(e.target.value)}>
              {categories.map(c => <option key={c}>{c}</option>)}
            </select>
            <select className="wl-filter-sel" value={filterStock} onChange={e => setFilterStock(e.target.value)}>
              {["All", "In Stock", "Out of Stock"].map(s => <option key={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div style={{ padding: "0 4px" }}>
          <DataTable columns={cols} rows={filtered} rowKey={(r) => r.id} />
        </div>
      </div>

      {toast && (
        <div className="wl-toast">
          <i className="bi bi-bell-fill" style={{ color: "#f5c89a" }}></i>
          {toast}
        </div>
      )}
    </div>
  );
}
